import { useDrag, useDrop } from 'react-dnd'
import { useDataValue } from 'Simple/Data.js'
import React, { useRef } from 'react'
import View from './view.js'

let ForwardedView = React.forwardRef((props, ref) => {
  return <View {...props} innerRef={ref} />
})

let ITEM_TYPE = 'ITEM'

function DraggableItem({ item, index, items, moveRow, isLast, ...props }) {
  let ref = useRef(null)
  let dragHandleRef = useRef(null)

  let [{ isActive }, drop] = useDrop({
    accept: ITEM_TYPE,
    collect: monitor => ({
      isActive: monitor.canDrop() && monitor.isOver(),
    }),
    hover(draggedItem) {
      if (draggedItem.index !== index) {
        moveRow(draggedItem.index, index)
        draggedItem.index = index
      }
    },
  })

  let [{ isDragging }, drag, dragPreview] = useDrag({
    type: ITEM_TYPE,
    item: { index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  drop(ref) // drop target is whole component
  drag(dragHandleRef) // drag source is only handle
  dragPreview(ref)

  return isLast || items.length === 2 ? (
    <View {...props} />
  ) : (
    <ForwardedView
      {...props}
      key={item.id}
      ref={ref}
      dragHandleRef={dragHandleRef}
      isDragging={isDragging}
      isActive={isActive}
    />
  )
}

export default function Logic(props) {
  let items = useDataValue({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let item = useDataValue({
    context: 'selected_stage',
    viewPath: props.viewPath,
  })

  let index = useDataValue({
    context: 'selected_stage_item',
    path: 'index',
    viewPath: props.viewPath,
  })

  let isLast = useDataValue({
    context: 'selected_stage_item',
    path: 'isLast',
    viewPath: props.viewPath,
  })

  async function moveRow(fromIndex, toIndex) {
    if (typeof props.onReorder !== 'function') return

    let updatedData = [...items]

    let [movedItem] = updatedData.splice(fromIndex, 1)
    updatedData.splice(toIndex, 0, movedItem)

    // Update the order field based on index
    await props.onReorder(
      updatedData.map((item, index) => ({
        ...item,
        order: index + 1,
      }))
    )
  }

  return (
    <DraggableItem
      {...props}
      items={items}
      key={item.id}
      item={item}
      isLast={isLast}
      index={index}
      moveRow={moveRow}
    />
  )
}
